import React, {
  useState,
  useMemo,
  useEffect,
  useRef,
  useImperativeHandle,
  memo,
} from 'react';
import _ from 'lodash-es';
import { useSafeState } from 'ahooks';
import { Table, Transfer, SearchBox, Select } from 'tea-component';
import Loading from '@/pages/datalab/components/Loading';
import { useGetTableHome } from '../../hoooks';
import './index.scss';
const { selectable, removeable, scrollable } = Table.addons;

interface ItransferRefProps<S = string> {
  dataRes: Array<{
    database: S;
    description: S;
    table: S;
  }>;
}
interface Iprops {
  game: string;
  modalRelevantStat: boolean;
  cloneDeepRelevantTables: (...args: any[]) => void;
  transferRef: ItransferRefProps;
}
const columns = [
  {
    key: 'data',
    header: 'Table',
    //
    render: (cvm: any) => <p>{`${cvm?.database}_${cvm?.table}`}</p>,
  },
];
function FollowNewGames({
  game,
  modalRelevantStat,
  cloneDeepRelevantTables,
  transferRef,
}: Iprops) {
  // 下拉
  const [selectvalue, setselectvalue] = useState('');
  // 右边选中的key
  const [targetKeys, setTargetKeys] = useState([]);
  // 搜索
  const [inputValue, setInputValue] = useState('');
  // 缓存第一次元数据
  const refMemoOptionsList = useRef([]);
  // 缓存第一次options数据
  const refMemoList = useRef([]);
  // 表更新，强制ref渲染
  const [refCheckoutbox, setrefCheckoutbox] = useState([]);
  // 表数据,初始化获取code,模态框打开,report
  const [loading, setLoading] = useSafeState(false);
  const timer = useRef();
  const {
    data = [],
    refresh,
    mutate,
  } = useGetTableHome(
    useMemo(() => ({ game }), [game]),
    modalRelevantStat,
  );

  // 因为是用ref来存储,请求直接被禁止了，整个生命周期可能只有一次loading，这里模拟一下
  useEffect(() => {
    setLoading(true);
    timer.current = setTimeout(() => {
      setLoading(false);
    }, 800);
    return () => clearTimeout(timer.current);
  }, []);

  useEffect(
    () => () => {
      // 页面进来先用上一次的数据
      mutate(refMemoList.current);
      // 如果缓存没了，重新请求一次
      if (_.isEmpty(refMemoList.current)) {
        refresh();
      }
    },
    [modalRelevantStat],
  );
  useEffect(() => {
    // 把第一次的值全部缓存起来，通过比较上一次缓存的值与当次传入的值是否全等，
    // 如果不是，则重新report一次，但是目前看情况是没有入参传入的，先直接保持三分钟的缓存时长，将请求禁用了
    if (!_.isEmpty(refMemoOptionsList.current)) return;
    const dataSource = _.uniqBy(data, 'database').map((task) => ({
      text: task?.database,
      value: task?.database,
    }));
    const keys = cloneDeepRelevantTables.map(
      (task) => `${task?.database}_${task?.table}`,
    );
    setTargetKeys(keys);
    setrefCheckoutbox(keys);
    refMemoOptionsList.current = dataSource;
    refMemoList.current = data?.map((task) => ({
      ...task,
      key: `${task?.database}_${task?.table}`,
    }));
  }, [cloneDeepRelevantTables, data, modalRelevantStat]);

  useEffect(() => {
    if (selectvalue) {
      const cloneDeep = refMemoList.current.filter(
        (task) => task.database === selectvalue,
      );
      setInputValue('');
      mutate(cloneDeep);
    }
  }, [selectvalue]);
  const targetKeySet = useMemo<any>(() => new Set(targetKeys), [targetKeys]);

  // 下拉框回调
  const handleOnChangSelectType = (value: React.SetStateAction<string>) => {
    setselectvalue(value);
  };
  // 勾选项点击回调
  const handleOnSelectTargetKeys = (
    keys: any,
    value: { selectedRecords: any[]; },
  ) => {
    const list = value?.selectedRecords.map((task) => task?.key);
    let res = _.uniq([...refCheckoutbox, ...list]);
    if (!value?.checked) {
      res = _.uniq([...refCheckoutbox, ...list]).filter(
        (task) => task !== value.recordKey,
      );
    }
    setrefCheckoutbox(res);
    setTargetKeys(res);
  };
  // 勾选项删除回调
  const hanldOnChangeRemove = (key: string) => {
    const res = targetKeys.filter((i) => i !== key);
    setTargetKeys(res);
    setrefCheckoutbox(res);
  };
  // 对父组件暴露的方法
  useImperativeHandle(
    transferRef,
    () => ({
      dataRes: _.uniqBy([...refMemoList.current, ...data], 'table').filter(
        (i: { table: string; }) => targetKeySet.has(i.key),
      ),
    }),
    [data, targetKeySet],
  );

  // 左侧数据源
  const dataSource = useMemo(
    () =>
      data
        .filter(
          (i: { table: string | string[]; }) =>
            i?.table.includes(inputValue) || i?.table.includes(inputValue),
        )
        ?.map((task) => ({ ...task, key: `${task?.database}_${task?.table}` })),
    [data, inputValue],
  );
  return (
    <>
      <div style={{ marginBottom: '20px' }}>
        <Select
          className="dbi-aigc-select"
          appearance="button"
          matchButtonWidth
          options={refMemoOptionsList.current}
          value={selectvalue}
          onChange={handleOnChangSelectType}
          placeholder="Database Select Database"
        />
      </div>
      <Transfer
        className="dbi-follow-new-games selection-centered"
        leftCell={
          <Transfer.Cell
            scrollable={false}
            title="ADD A Table"
            header={
              <>
                <SearchBox
                  value={inputValue}
                  onChange={(value: any) => setInputValue(value)}
                  placeholder="Search"
                />
              </>
            }
          >
            {data.length !== 0 ? (
              data.filter(
                (i: { table: string | string[]; }) =>
                  i?.table.includes(inputValue) ||
                  i?.table.includes(inputValue),
              ).length !== 0 ? (
                  <SourceTable
                    dataSource={dataSource}
                    targetKeys={targetKeys}
                    onChange={handleOnSelectTargetKeys}
                    loading={loading}
                  />
                ) : (
                  <div className="dbi-table-no-data">
                  No search results
                    <br />
                  (Mobile Games Only)
                  </div>
                )
            ) : (
              <div className="dbi-table-no-data">Please search a game</div>
            )}
          </Transfer.Cell>
        }
        rightCell={
          <Transfer.Cell
            scrollable={false}
            title={`Selected (${targetKeys.length})`}
          >
            {refMemoList.current?.filter((i) => targetKeySet.has(i.key))
              .length !== 0 ? (
                <TargetTable
                  dataSource={refMemoList.current.filter((i) =>
                    targetKeySet.has(i.key),
                  )}
                  onRemove={hanldOnChangeRemove}
                />
              ) : (
                <div className="dbi-table-no-data">Please select a game</div>
              )}
          </Transfer.Cell>
        }
      />
    </>
  );
}

function SourceTable({ dataSource, targetKeys, onChange, loading }) {
  return (
    <Loading loading={loading} style={{ marginTop: '0' }}>
      <Table
        className="dbi-source-table"
        records={loading ? [] : dataSource}
        hideHeader
        recordKey="key"
        columns={columns}
        addons={[
          scrollable({
            virtualizedOptions: {
              height: 335,
              itemHeight: 64,
            },
            onScrollBottom: () => console.log('Bottom'),
          }),
          selectable({
            value: targetKeys,
            onChange,
            rowSelect: true,
          }),
        ]}
      />
    </Loading>
  );
}

function TargetTable({ dataSource, onRemove }) {
  return (
    <Table
      className="dbi-target-table"
      records={dataSource}
      recordKey="key"
      columns={columns}
      addons={[
        scrollable({
          virtualizedOptions: {
            height: 335,
            itemHeight: 64,
          },
        }),
        removeable({ onRemove }),
      ]}
    />
  );
}
export default memo(FollowNewGames);
